import { Routes, Route, Navigate } from 'react-router-dom';
import { MainLayout } from '@/components/layout';
import { HomePage } from '@/features/home';
import { CatalogPage } from '@/features/catalog';
import { ProductDetailPage } from '@/features/product-detail';
import { ContactPage } from '@/features/contact';
import { AboutPage } from '@/features/about';
import { ProjectsPage } from '@/features/projects';
import { BusinessCardPage } from '@/features/business-card';
import { LoginPage } from '@/features/admin/pages/LoginPage';
import { DashboardPage } from '@/features/admin/pages/DashboardPage';
import { CategoriesPage } from '@/features/admin/pages/CategoriesPage';
import { ProductsPage } from '@/features/admin/pages/ProductsPage';
import { InquiriesPage } from '@/features/admin/pages/InquiriesPage';
import { FeaturedCategoriesPage } from '@/features/admin/pages/FeaturedCategoriesPage';
import { FeaturedProductsPage } from '@/features/admin/pages/FeaturedProductsPage';
import { AdminLayout } from '@/features/admin/layout/AdminLayout';
import { ProtectedAdminRoute } from '@/features/admin/components/ProtectedAdminRoute';

function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/products" element={<CatalogPage />} />
        <Route path="/products/:slug" element={<ProductDetailPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Route>

      {/* Hidden Pages (not in menu) */}
      <Route path="/kartvizit" element={<BusinessCardPage />} />

      {/* Admin Routes */}
      <Route path="/admin/login" element={<LoginPage />} />

      <Route path="/admin" element={<ProtectedAdminRoute />}>
        <Route element={<AdminLayout />}>
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="categories" element={<CategoriesPage />} />
          <Route path="featured-categories" element={<FeaturedCategoriesPage />} />
          <Route path="featured-products" element={<FeaturedProductsPage />} />
          <Route path="products" element={<ProductsPage />} />
          <Route path="inquiries" element={<InquiriesPage />} />
          {/* Redirect /admin to dashboard */}
          <Route index element={<Navigate to="dashboard" replace />} />
        </Route>
      </Route>

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;

